import React from "react";
import { useEffect } from "react";
import { ContextLanguage } from "../../context/Context.Language";
// import FunctionRepleteFont from "../../utils/FunctionRepleteFont";
import { TEXT_CONFIRM } from "../../utils/useConstants";
import { FunctionFormatNewLine } from "../../utils/useFunction";
import { useIsMobile } from "../../utils/useIsMobile";
import {
  STYLE_BG_BLUE_DRAWER_INFO,
  STYLE_BG_MODAL,
  STYLE_BG_OPACITY_MODAL,
  STYLE_BG_TRANSPARENT_MODAL,
  STYLE_BG_WHITE_DRAWER_INFO,
  STYLE_BORDER_BLUE,
  STYLE_BUTTON_BLUE,
  STYLE_IMG_DRAWER_INFO,
  STYLE_MAX_WIDTH_DESKTOP,
  STYLE_SUBTITLE_BOLD,
  STYLE_TEXT_DES_DRAWER_INFO,
} from "../../utils/useStyle";
import { BlueButton } from "../attributes/Button";

const AccessoryLoadingRing = () => {
  return (
    <svg
      className="animate-spin -ml-1 mr-3 h-5 w-5 text-white"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
    >
      <circle
        className="opacity-25"
        cx={12}
        cy={12}
        r={10}
        stroke="currentColor"
        strokeWidth={4}
      />
      <path
        className="opacity-75"
        fill="currentColor"
        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
      />
    </svg>
  );
};

export const DrawerInfoMobile = ({
  setOpen,
  open,
  info,
  disabled = false,
  acceptText = TEXT_CONFIRM,
  cancelText,
  showCloseButton = true,
  showSaveButton = true,
  error,
  hidden,
  save,
  clearInput,
  createLoading = null,
  isButtonFullWidth = false,
}) => {
  useEffect(() => {
    window.history.pushState(null, null, window.location.pathname);
    window.addEventListener("popstate", onBackButtonEvent);
    return () => {
      window.removeEventListener("popstate", onBackButtonEvent);
    };
  }, []);

  const onBackButtonEvent = (e) => {
    e.preventDefault();
    setOpen(false);
  };
  const onSubmit = async () => {
    if (save) {
      await save();
    }
    setOpen(false);
  };

  const onClose = () => {
    if (clearInput) {
      clearInput();
    }
    setOpen(false);
  };

  const { language } = React.useContext(ContextLanguage);

  return (
    <div
      className={`${
        open ? STYLE_BG_OPACITY_MODAL : STYLE_BG_TRANSPARENT_MODAL
      } ${STYLE_BG_MODAL}`}
    >
      <div
        className={`${
          open ? "h-full inset-0  " : " h-0 w-0  "
        } transition-shadow  duration-500 fixed  `}
      >
        {open && (
          <React.Fragment>
            <div className={STYLE_BG_WHITE_DRAWER_INFO}>{info}</div>
            <div
              className={`${
                hidden ? " hidden " : ""
              }+" bg-white rounded-xl h-13 z-10 px-4  md:px-6 pt-4 pb-10 md:pt-6 md:pb-6 fixed bottom-0 w-full  grid ${
                isButtonFullWidth ? " grid-cols-1 " : " grid-cols-2 "
              } gap-2 md:gap-6 "`}
            >
              {error && <div>{error}</div>}
              {showCloseButton && (
                <button
                  type="button"
                  className={`${STYLE_BORDER_BLUE(language)}`}
                  onClick={() => onClose()}
                >
                  {cancelText}
                </button>
              )}
              {showSaveButton && (
                <button
                  disabled={disabled}
                  type="button"
                  className={`${
                    createLoading || disabled
                      ? "bg-gray-400 cursor-not-allowed "
                      : STYLE_BUTTON_BLUE(language)
                  } ${
                    language === "TH" ? " text-base-th " : " text-base "
                  } w-full inline-flex justify-center items-center    focus:outline-none`}
                  onClick={disabled ? () => {} : () => onSubmit()}
                >
                  {createLoading ? (
                    <AccessoryLoadingRing />
                  ) : (
                    acceptText[language]
                  )}
                </button>
              )}
            </div>
          </React.Fragment>
        )}
      </div>
    </div>
  );
};

export const DrawerInfo = ({
  setOpen,
  open,
  title,
  image,
  description,
  parentDrawerInfo,
  description2,
  imageMobile,
}) => {
  const isMobile = useIsMobile();

  const { language } = React.useContext(ContextLanguage);

  // React.useEffect(() => {
  //   FunctionRepleteFont({ language });
  // }, [open]);

  // const count = description?.split(" ")?.length;
  // const part_one = description?.split(" ")?.slice(0, count / 2);
  // const part_two = description?.split(" ")?.slice(count / 2, count);

  React.useEffect(() => {
    if (open) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }
  }, [open]);

  const FunctionSetOpenFalse = () => {
    setOpen(false);
  };

  return (
    <div className={parentDrawerInfo}>
      <div
        style={{
          zIndex: 9999999,
        }}
        onClick={() => FunctionSetOpenFalse()}
        className={`${
          open ? STYLE_BG_OPACITY_MODAL : STYLE_BG_TRANSPARENT_MODAL
        } ${STYLE_BG_MODAL}`}
      >
        <div
          className={`${
            open ? " h-full inset-0  " : " h-0 w-0  "
          } transition-shadow  duration-500 fixed  `}
        >
          {open && (
            <React.Fragment>
              <div
                onClick={(event) => {
                  event.stopPropagation();
                }}
                className={`bg-white rounded-t-2xl text-white text-center absolute bottom-0 ${
                  isMobile ? " h-auto max-h-[600px] " : ""
                }`}
              >
                <div className=" relative overflow-hidden">
                  <img
                    src={
                      isMobile
                        ? "/images/bg_blue_mb.png"
                        : "/images/bg_blue.png"
                    }
                    className={STYLE_BG_BLUE_DRAWER_INFO}
                  />
                  {/* <div
                    onClick={() => {
                      setOpen(false);
                    }}
                    className={STYLE_LINE_MB}
                  ></div> */}
                  {image ? (
                    <img
                      src={isMobile ? imageMobile : image}
                      className={STYLE_IMG_DRAWER_INFO}
                    />
                  ) : (
                    <React.Fragment />
                  )}
                </div>
                <div className={STYLE_MAX_WIDTH_DESKTOP}>
                  <div className="pb-[106px] md:pb-[0px]">
                    <div
                      className={`${STYLE_SUBTITLE_BOLD} ${
                        language === "TH" ? " text-22-th " : " text-22 "
                      } mt-4 mb-2 md:mt-6.5 leading-6 md:leading-8`}
                    >
                      {title}
                    </div>
                    <div className={STYLE_TEXT_DES_DRAWER_INFO(language)}>
                      <div
                        className={
                          description && description2
                            ? ` leading-5 md:leading-6 md:text-left grid grid-cols-1 md:grid-cols-2 gap-0 md:gap-6  ${
                                isMobile
                                  ? " overflow-y-scroll h-auto max-h-[210px] "
                                  : ""
                              } `
                            : String(description)?.length > 120
                            ? `leading-5 md:leading-6 md:text-left grid grid-cols-1  gap-6 `
                            : `leading-5 md:leading-6 md:text-left grid grid-cols-1  gap-6 `
                        }
                        // className={`leading-5 md:leading-6 md:text-justify grid grid-cols-1 md:grid-cols-2 gap-6`}
                      >
                        {description && description2 ? (
                          <React.Fragment>
                            <div> {FunctionFormatNewLine(description)}</div>
                            <div>{FunctionFormatNewLine(description2)}</div>
                          </React.Fragment>
                        ) : (
                          <div
                            className={
                              description &&
                              !description2 &&
                              description?.length < 120
                                ? "text-center"
                                : ""
                            }
                          >
                            {FunctionFormatNewLine(description)}
                          </div>
                        )}
                        {/* {description && description2 ? (
                          <React.Fragment>
                            <div> {FunctionFormatNewLine(description)}</div>
                            <div>{FunctionFormatNewLine(description2)}</div>
                          </React.Fragment>
                        ) : (
                          <React.Fragment>
                            <div>{part_one?.join(" ")}</div>
                            <div>{part_two?.join(" ")}</div>
                          </React.Fragment>
                        )} */}
                      </div>
                    </div>
                  </div>

                  <div
                    className={` w-full px-4 md:px-10 xl:px-padding_read pt-4 md:py-8 bg-white  max-w-desktop mx-auto h-[106px] md:h-[124px] fixed md:static bottom-0 `}
                  >
                    <BlueButton
                      onClick={() => FunctionSetOpenFalse()}
                      title={`Ok`}
                    />
                  </div>
                </div>
              </div>
            </React.Fragment>
          )}
        </div>
      </div>
    </div>
  );
};
